module.exports = __webpack_public_path__ + "img/visu-stockage-flora@2x.bb455f3b.jpg";